import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '@shared-lib/components/icon/icon.component';

@Component({
  selector: 'cp-widget-header',
  imports: [CommonModule, IconComponent],
  templateUrl: './widget-header.component.html',
  styleUrl: './widget-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetHeaderComponent {
  @Input({ required: true }) text: string;
  @Input({ required: true }) icon: string;
  @Input() isAbsolutePosition: boolean;
  @Input() variant: 'remortgage-guide' | 'light' | 'orange' | 'green' | 'blue';
}
